import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { EffectFade, Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HeroSlider = () => {
  const swiperRef = useRef(null);
  const swiperInstance = useRef(null);

  const slides = [
    {
      bg: '/assets/images/slider/slide1.jpg',
      subtitle: 'Get unforgettable pleasure with us',
      title: 'Natural Wonder of the world',
    },
    {
      bg: '/assets/images/slider/slide2.jpg',
      subtitle: 'Get unforgettable pleasure with us',
      title: "Let's make your best trip with us",
    },
    {
      bg: '/assets/images/slider/slide3.jpg',
      subtitle: 'Get unforgettable pleasure with us',
      title: 'Explore beauty of the whole world',
    },
    {
      bg: '/assets/images/slider/slide3.jpg',
      subtitle: 'Get unforgettable pleasure with us',
      title: 'Explore beauty of the whole world',
    },
  ];

  useEffect(() => {
    // Log to verify Swiper is imported


    if (swiperRef.current && typeof Swiper !== 'undefined') {
      // Destroy existing instance
      if (swiperInstance.current) {
        swiperInstance.current.destroy();
      }

      // Create new Swiper
      swiperInstance.current = new Swiper(swiperRef.current, {
        modules: [EffectFade, Autoplay, Navigation, Pagination],
        effect: 'fade',
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        },
        pagination: {
          el: '.slider-pagination',
          clickable: true,
        },
        speed: 1000,
      });

   
    } else {
      console.warn('Swiper not available or element not found');
    }

    return () => {
      if (swiperInstance.current) {
        swiperInstance.current.destroy();
      }
    };
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="w-full" style={{ width: '100% !important' }} id="slider-sec">
      <div className="th-hero-wrapper hero-1" id="hero" style={{ width: '100% !important' }}>
        <div className="swiper th-slider hero-slider-1" ref={swiperRef}>
          <div className="swiper-wrapper">
            {slides.map((slide, index) => (
              <div className="swiper-slide" key={index}>
                <div className="hero-inner">
                  <div
                    className="th-hero-bg"
                    style={{
                      backgroundImage: `url(${slide.bg})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      minHeight: '100vh',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div className="container">
                      <div className="hero-style1">
                        <span className="sub-title style1">{slide.subtitle}</span>
                        <h1 className="hero-title">{slide.title}</h1>
                        <div className="btn-group">
                          <a 
                            href="#tour-sec" 
                            className="th-btn th-icon"
                            onClick={(e) => handleNavClick(e, '#tour-sec')}
                          >
                            Explore Tours
                          </a>
                          <a 
                            href="#sercices-sec" 
                            className="th-btn style2 th-icon"
                            onClick={(e) => handleNavClick(e, '#sercices-sec')}
                          >
                            Our Services
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="th-swiper-custom">
            <button className="slider-arrow slider-prev">‹</button>
            <div className="slider-pagination"></div>
            <button className="slider-arrow slider-next">›</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;